class RealTimeStock {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="RealTimeStock"]'),
      lang: document.documentElement.lang || 'nl',
      ...options
    };
  }

  static getStockStates(module) {
    return {
      available: {
        stateClass: 'is-available',
        text: module.dataset.availableText,
        tooltip: module.dataset.availableTooltip
      },
      'not-available': {
        stateClass: 'is-not-available',
        text: module.dataset.notAvailableText,
        tooltip: module.dataset.notAvailableTooltip
      },
      'is-limited': {
        stateClass: 'is-available',
        text: module.dataset.availableText,
        tooltip: module.dataset.limitedTooltip
      }
    };
  }

  init() {
    const { moduleList, lang } = this.config;

    moduleList.forEach(module => {
      const {
        productId,
        errorMessage,
        enabledRealtimeStock,
        minStockAmount,
        productStatus,
        deliveryTooltip,
        deliveryTime,
        noStockTooltip,
        noCurrentStockTooltip,
        nextDayDeliveryTooltip,
        notAvailableText,
        authenticated
      } = module.dataset;
      const container = module.querySelector('[data-module-child="Container"]');
      const indicator = module.querySelector('[data-module-child="Indicator"]');
      const text = module.querySelector('[data-module-child="Text"]');
      const stockStates = RealTimeStock.getStockStates(module);
      const timedStatusses = ['2', '8', '9', 'A', 'F', 'G'];
      const isDefaultProduct = productStatus === '0' || productStatus === '1';
      const isTimedProduct = timedStatusses.includes(productStatus);
      const isBC4 = productStatus === '4';
      const isBC5 = productStatus === '5';
      const isBC7 = productStatus === '7';
      const isAuthenticated = authenticated === 'True';
      if (productId && container && indicator && text) {
        module.classList.add('is-loading');

        // real-time stock is switched on via a dataset, can be adjusted in the future with product attributes
        // dataset is always a string value, check on the real value "1"
        if (enabledRealtimeStock === '1') {
          fetch(`/api/v2/catalog/product/${productId}/stock`, {
            method: 'GET',
            headers: {
              'Accept-Language': lang
            }
          })
            .then(res => res.json())
            .then(json => {
              if (!json) {
                indicator.classList.add('data-tooltip', stockStates['not-available'].stateClass);
                indicator.setAttribute('data-tooltip', `${noStockTooltip}`);
                text.innerHTML = '';
                text.appendChild(document.createTextNode(stockStates['not-available'].text));
                module.classList.remove('is-loading');
                container.classList.remove('hidden');
                return;
              }
              const { isInStock, amountInStock, stockBranches } = json;
              if (amountInStock <= 0) {
                const elementOutStock = document.querySelector(
                  `[data-has-stock="false-${productId}"]`
                );
                if (elementOutStock) {
                  elementOutStock.style.display = 'block';
                }
              }
              let stateKey = isInStock ? 'available' : 'not-available';
              let stockLocationText = '';
              if (isDefaultProduct) {
                stockLocationText = isInStock ? `${deliveryTooltip}` : `${noCurrentStockTooltip}`;

                if (minStockAmount && isInStock && amountInStock < minStockAmount) {
                  stateKey = 'is-limited';
                }

                if (isInStock) {
                  stockBranches.unshift({
                    name: 'Distributie',
                    stock: amountInStock
                  });
                }

                stockBranches.forEach((stockBranch, index) => {
                  if (isInStock && parseInt(stockBranch.stock, 10) > 0) {
                    stockLocationText += `\n ${stockBranch.name}: ${stockBranch.stock} voorraad${
                      index + 1 < stockBranches.length ? ', ' : ''
                    }`;
                  } else {
                    stockLocationText += isInStock
                      ? `\n ${stockBranch.name}: ${nextDayDeliveryTooltip}`
                      : `\n ${stockBranch.name}: ${notAvailableText}`;
                  }
                });
              }
              if (isTimedProduct) {
                const tppTime = parseInt(deliveryTime, 10) + 3;
                stockLocationText +=
                  deliveryTime <= 25
                    ? 'Momenteel geen voorraad. Indicatieve levertijd ca '
                    : 'Momenteel geen voorraad. Levertijd weten? Neem contact met ons op.';
                if (tppTime <= 5) {
                  stockLocationText += '3-5 dagen';
                } else if (tppTime <= 7) {
                  stockLocationText += '5-7 dagen';
                } else if (tppTime <= 10) {
                  stockLocationText += '7-10 dagen';
                } else if (tppTime <= 15) {
                  stockLocationText += '10-15 dagen';
                } else if (tppTime <= 21) {
                  stockLocationText += '2-3 weken';
                } else if (tppTime <= 28) {
                  stockLocationText += '3-4 weken';
                }
              }
              if (isBC4 || isBC5) {
                const { bcFourTooltip, bcFiveTooltip } = module.dataset;
                if (isBC4) {
                  stockLocationText += `${bcFourTooltip}`;
                }
                if (isBC5) {
                  stockLocationText += `${bcFiveTooltip}`;
                }

                if (amountInStock <= 0) {
                  stateKey = 'not-available';
                } else {
                  stateKey = 'is-limited';
                }

                if (isInStock) {
                  stockBranches.unshift({
                    name: 'Distributie',
                    stock: amountInStock
                  });
                }

                if (stockBranches) {
                  stockBranches.forEach((stockBranch, index) => {
                    if (isInStock && parseInt(stockBranch.stock, 10) > 0) {
                      stockLocationText += `\n ${stockBranch.name}: ${stockBranch.stock} voorraad${
                        index + 1 < stockBranches.length ? ', ' : ''
                      }`;
                    } else {
                      stockLocationText += `\n ${stockBranch.name}: ${notAvailableText}`;
                    }
                  });
                }
              }

              if (isBC7) {
                const { bcSevenTooltip } = module.dataset;
                stockLocationText += `${bcSevenTooltip}`;
                stateKey = 'not-available';
              }

              indicator.classList.add('data-tooltip', stockStates[stateKey].stateClass);
              if (isAuthenticated) {
                indicator.setAttribute('data-tooltip', stockLocationText);
              } else {
                indicator.classList.remove('c-tooltip', 'c-tooltip--top');
              }

              text.innerHTML = '';
              text.appendChild(document.createTextNode(stockStates[stateKey].text));
              module.classList.remove('is-loading');
              container.classList.remove('hidden');
            })
            .catch(error => {
              module.classList.add('is-error');
              module.appendChild(document.createTextNode(errorMessage || 'Stock not available'));
              module.classList.remove('is-loading');
              console.log(error);
            });
        } else {
          const stateKey = 'available';
          indicator.classList.add('data-tooltip', stockStates[stateKey].stateClass);
          indicator.setAttribute('data-tooltip', stockStates[stateKey].tooltip);
          text.innerHTML = '';
          text.appendChild(document.createTextNode(stockStates[stateKey].text));
          module.classList.remove('is-loading');
          container.classList.remove('hidden');
        }
      }
    });
  }
}

export default RealTimeStock;
